import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  data: function data() {
    return {
      // 查看生产报告
      searchForm: {
        page: 1,
        limit: 10,
        sortField: 'report_date'
      },
      dayjs: dayjs,
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      pupopShow: false,
      reportDetail: [],
      dialogShow: false
    };
  },
  methods: {
    // 查看生产报告
    query: function query() {
      var _this = this;
      this.queryLoading = true;
      this.pupopShow = true;
      this.$api['dailyReportQuery'](this.searchForm).then(function (res) {
        _this.tableData = res.data || [];
        _this.totalCount = res.count;
        _this.queryLoading = false;
      });
    },
    look: function look(id) {
      var _this2 = this;
      this.$api['dailyReportDetail'](id).then(function (res) {
        _this2.reportDetail = res.data ? JSON.parse(res.data.answer).history : [];
        console.log('this.reportDetail', _this2.reportDetail);
        _this2.dialogShow = true;
      });
    },
    dailyReports: function dailyReports(idx) {
      var _this3 = this;
      var loading = this.$loading({
        lock: true,
        text: '数据加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$api['dailyReportCreate']({
        idx: idx
      }).then(function (res) {
        _this3.query();
        loading.close();
      });
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};